import type {
  Integration,
  IntegrationDetail,
  IntegrationType,
} from "@/types/integration";

import { INTEGRATION_PROVIDER, INTEGRATION_TYPE } from "@/types/integration";

/**
 * One connected ClinicSoft, because the demo workspace is a clinic.
 *
 * Without this every CRM-gated surface - the MRN sync on a contact, the doctors
 * sync, the appointment partner-app panel - renders as "no CRM connected" in
 * mock mode, which is the one state a clinic demo should not be showing.
 *
 * The name is the workspace's own label for the integration rather than the
 * product name, matching what the real API returns and what the sync response
 * echoes back, so the button and its toast agree.
 */
const SEEDS: Integration[] = [
  {
    id: "mock-integration-clinicsoft",
    type: INTEGRATION_TYPE.CRM,
    provider: INTEGRATION_PROVIDER.CLINICSOFT,
    name: "ClinicSoft",
    isActive: true,
    eventsProcessed: 1284,
    lastEventAt: "2026-09-06T08:40:00.000Z",
    createdAt: "2026-07-01T09:00:00.000Z",
    updatedAt: "2026-07-01T09:00:00.000Z",
  },
];

export const CLINICSOFT_MOCK_INTEGRATION = SEEDS[0];

export function getIntegrationsMock(type?: IntegrationType): Integration[] {
  return type
    ? SEEDS.filter((integration) => integration.type === type)
    : SEEDS;
}

/** The detail the real API returns: masked secrets plus the webhook it listens on. */
export function getIntegrationMock(id: string): IntegrationDetail | undefined {
  const seed = SEEDS.find((integration) => integration.id === id);

  if (!seed) return undefined;

  return {
    ...seed,
    identifier: "cs9-himalaya",
    config: {
      baseUrl: "https://himalaya.hitechsoftwares.com:36020",
      permitNo: "MOH-F-10001",
      apiKey: "••••••••••••",
      username: "replyn-sync",
      password: "••••••••",
    },
    webhookUrl:
      "https://api.replyn.app/v1/integrations/webhook/clinicsoft/cs9-himalaya",
  };
}
